import { useEffect, useState } from 'react'
import { Alert, Box, CircularProgress, Dialog, DialogContent, useMediaQuery, useTheme } from '@mui/material'
import RequestModalCard from './RequestModalCard'
import requestStore from '../../stores/requestStore'
import organizationSessionStore from '../../stores/organizationSessionStore'

export default function RequestDetailDialog({ open, request, onClose }) {
	const theme = useTheme()
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
	const [detail, setDetail] = useState(null)
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState(null)
	const requestId = request?.id || request?.requestId

	useEffect(() => {
		if (!open || !requestId) return undefined
		let active = true
		const generation = organizationSessionStore.contextGeneration
		setDetail(null)
		setError(null)
		setLoading(true)
		requestStore.fetchRequestDetail(requestId)
			.then(value => {
				if (active && generation === organizationSessionStore.contextGeneration) {
					if (value) setDetail(value)
					else setError('Заявка недоступна')
				}
			})
			.catch(() => {
				if (active && generation === organizationSessionStore.contextGeneration) setError('Не удалось загрузить заявку')
			})
			.finally(() => {
				if (active && generation === organizationSessionStore.contextGeneration) setLoading(false)
			})
		return () => { active = false }
	}, [open, requestId])
	if (!request) return null
	return <Dialog open={open} onClose={onClose} fullScreen={isMobile} maxWidth='lg' fullWidth>
		<DialogContent>
			{loading && <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}><CircularProgress /></Box>}
			{error && <Alert severity='error'>{error}</Alert>}
			{detail && <RequestModalCard
				onClose={onClose}
				requestId={detail.id}
				boardId={detail.boardId}
				columnId={detail.columnId}
				title={detail.title}
				description={detail.description}
				addressShort={detail.addressShort}
				extraFilter={detail.filter?.extraFilter || detail.filter}
				requestFilter={detail.filter}
				jsonFileName={detail.filter?.jsonFileName}
				countryCodeISO={detail.countryCodeISO || detail.filter?.countryCodeISO}
				uuid={detail.uuid}
				outcome={detail.outcome}
				closedAt={detail.closedAt}
				sourceId={detail.sourceId}
				clientId={detail.clientId}
				client={detail.client}
				permissions={detail.permissions}
			/>}
		</DialogContent>
	</Dialog>
}
